import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'AP',
  name: 'Andrea P.',
  role: 'High School Research Methods Teacher — London, UK',
  text: '"My students finally understand the difference between quantitative and qualitative research. Before this, I was the one wasting time searching for how to explain it clearly. Now I walk into the classroom with everything ready."'
}, {
  initials: 'CM',
  name: 'Carlos M.',
  role: 'Research Methods Educator — Toronto, Canada',
  text: '"I never walk into class anymore without knowing exactly how to explain the research problem or the difference between research designs. This resource does the heavy lifting for me."'
}, {
  initials: 'SL',
  name: 'Sofia L.',
  role: 'High School Teacher — Sydney, Australia',
  text: '"The lesson planning templates save me hours every single week. I never improvise in front of my students anymore."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4" data-id="element-270">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-271">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-272">
              <div className="flex gap-1 text-gold mb-4" data-id="element-273">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-274" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-275">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-276">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-277">
                  {t.initials}
                </div>
                <div data-id="element-278">
                  <div className="font-bold text-white text-sm" data-id="element-279">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-280">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}